/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: string;
};

export type Dashboard = {
  __typename?: "Dashboard";
  dashboardId: Scalars["String"];
  parentId?: Maybe<Scalars["String"]>;
  type?: Maybe<DashboardType>;
  name?: Maybe<Scalars["String"]>;
  title: Scalars["String"];
  owner?: Maybe<Scalars["String"]>;
  ownerName?: Maybe<Scalars["String"]>;
  layout?: Maybe<DashboardLayout>;
  widgets?: Maybe<Array<Maybe<DashboardWidget>>>;
  featureFlags?: Maybe<Array<Scalars["String"]>>;
  createdDate: Scalars["DateTime"];
  updateDate: Scalars["DateTime"];
};

export type DashboardInput = {
  parentId?: Maybe<Scalars["String"]>;
  title?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
  layout?: Maybe<DashboardLayoutInput>;
  widgets?: Maybe<Array<Maybe<DashboardWidgetInput>>>;
};

export type DashboardLayout = {
  __typename?: "DashboardLayout";
  format: Scalars["String"];
  width: Scalars["Int"];
  height: Scalars["Int"];
};

export type DashboardLayoutInput = {
  format?: Maybe<Scalars["String"]>;
  width?: Maybe<Scalars["Int"]>;
  height?: Maybe<Scalars["Int"]>;
};

export type DashboardUpdate = {
  dashboardId?: Maybe<Scalars["String"]>;
  parentId?: Maybe<Scalars["String"]>;
  title?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
  layout?: Maybe<DashboardLayoutInput>;
  widgets?: Maybe<Array<Maybe<DashboardWidgetUpdate>>>;
};

export type DashboardWidget = {
  __typename?: "DashboardWidget";
  widgetId: Scalars["String"];
  title: Scalars["String"];
  type: Scalars["String"];
  x: Scalars["Int"];
  y: Scalars["Int"];
  width: Scalars["Int"];
  height: Scalars["Int"];
  settings?: Maybe<Scalars["String"]>;
  featureFlags?: Maybe<Array<Scalars["String"]>>;
};

export type DashboardWidgetInput = {
  title?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
  x?: Maybe<Scalars["Int"]>;
  y?: Maybe<Scalars["Int"]>;
  width?: Maybe<Scalars["Int"]>;
  height?: Maybe<Scalars["Int"]>;
  settings?: Maybe<Scalars["String"]>;
};

export type DashboardWidgetUpdate = {
  widgetId?: Maybe<Scalars["String"]>;
  title?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
  x?: Maybe<Scalars["Int"]>;
  y?: Maybe<Scalars["Int"]>;
  width?: Maybe<Scalars["Int"]>;
  height?: Maybe<Scalars["Int"]>;
  settings?: Maybe<Scalars["String"]>;
};

export type WorkspaceType = "Personal" | "Organization" | "Shared";
export type DashboardType = "Personal" | "Organization" | "System";

export const DASHBOARD_TYPES: Record<DashboardType, DashboardType> = {
  Personal: "Personal",
  Organization: "Organization",
  System: "System"
} as const;

export type Workspace = {
  __typename?: "Workspace";
  workspaceId: Scalars["String"];
  title: Scalars["String"];
  owner: Scalars["String"];
  ownerName?: Maybe<Scalars["String"]>;
  type?: Maybe<WorkspaceType>;
  defaultProject?: Maybe<Scalars["String"]>;
  dashboards?: Maybe<Array<Maybe<WorkspaceDashboard>>>;
  createdDate: Scalars["DateTime"];
  updateDate: Scalars["DateTime"];
};

export type WorkspaceDashboard = {
  __typename?: "WorkspaceDashboard";
  dashboardId: Scalars["String"];
  favourite: Scalars["Boolean"];
  title?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  owner?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
  widgetTypes?: Maybe<Array<Maybe<Scalars["String"]>>>;
  featureFlags?: Maybe<Array<Scalars["String"]>>;
};

export type WorkspaceDashboardInput = {
  dashboardId?: Maybe<Scalars["String"]>;
  favourite?: Maybe<Scalars["Boolean"]>;
};

export type WorkspaceInput = {
  title?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
  defaultProject?: Maybe<Scalars["String"]>;
  dashboards?: Maybe<Array<Maybe<WorkspaceDashboardInput>>>;
};

export type WorkspaceMutation = {
  __typename?: "WorkspaceMutation";
  addWorkspace?: Maybe<Workspace>;
  updateWorkspace?: Maybe<Scalars["Boolean"]>;
  deleteWorkspace?: Maybe<Scalars["Boolean"]>;
  addWorkspaceDashboard?: Maybe<Scalars["Boolean"]>;
  removeWorkspaceDashboard?: Maybe<Scalars["Boolean"]>;
  addDashboard?: Maybe<Dashboard>;
  updateDashboard?: Maybe<Scalars["Boolean"]>;
  deleteDashboard?: Maybe<Scalars["Boolean"]>;
};

export type WorkspaceMutationAddWorkspaceArgs = {
  workspace: WorkspaceInput;
};

export type WorkspaceMutationUpdateWorkspaceArgs = {
  workspace: WorkspaceUpdate;
};

export type WorkspaceMutationDeleteWorkspaceArgs = {
  id: Scalars["String"];
};

export type WorkspaceMutationAddWorkspaceDashboardArgs = {
  workspaceId: Scalars["String"];
  dashboardId: Scalars["String"];
  position?: Maybe<Scalars["Int"]>;
};

export type WorkspaceMutationRemoveWorkspaceDashboardArgs = {
  workspaceId: Scalars["String"];
  dashboardId: Scalars["String"];
};

export type WorkspaceMutationAddDashboardArgs = {
  dashboard: DashboardInput;
  workspaceId?: Maybe<Scalars["String"]>;
  position?: Maybe<Scalars["Int"]>;
};

export type WorkspaceMutationUpdateDashboardArgs = {
  dashboard: DashboardUpdate;
};

export type WorkspaceMutationDeleteDashboardArgs = {
  id: Scalars["String"];
};

export type SystemWidgetConfig = {
  __typename?: "SystemWidgetConfig";
  widgetType: Scalars["String"];
  featureFlags?: Maybe<Array<Scalars["String"]>>;
};

export type WorkspaceQuery = {
  __typename?: "WorkspaceQuery";
  workspaces?: Maybe<Array<Maybe<Workspace>>>;
  workspace?: Maybe<Workspace>;
  dashboards?: Maybe<Array<Maybe<Dashboard>>>;
  dashboard?: Maybe<Dashboard>;
  widgetConfigs?: Maybe<Array<Maybe<SystemWidgetConfig>>>;
};

export type WorkspaceQueryWorkspaceArgs = {
  id?: Maybe<Scalars["String"]>;
};

export type WorkspaceQueryDashboardArgs = {
  id: Scalars["String"];
};

export type WorkspaceUpdate = {
  workspaceId?: Maybe<Scalars["String"]>;
  title?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
  defaultProject?: Maybe<Scalars["String"]>;
  dashboards?: Maybe<Array<Maybe<WorkspaceDashboardInput>>>;
};
